import { Editor, Range } from 'slate';

export function isExpanded(editor: Editor) {
    const { selection } = editor;

    return selection && Range.isExpanded(selection);
}
